import React, { useRef, useState, useEffect } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import { css } from "@emotion/react";
import {ReactComponent as Profile} from 'src/assets/modal/ProfileM.svg';
import {ReactComponent as Bg} from 'src/assets/modal/BgM.svg';
import {ReactComponent as Close} from 'src/assets/close.svg';

interface ImageCropProps {
    image: string;
    onClose: () => void;
    onCrop: (cropData: string) => void;
    imageType? : "background" | "profile" | null;
}

const ImageCrop = ({ image, onClose, onCrop, imageType }: ImageCropProps) => {


    const [img, setImage] = useState(image);
    const cropperRef = useRef<ReactCropperElement | null>(null);
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        setImage(image);
    }, [image]);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result as string);
            };
            reader.readAsDataURL(file);
        }
    };

    const handleChangeImage = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click(); // 파일 입력 클릭
        }
    };

    const handleCrop = () => {
        if (cropperRef.current) {
            const croppedImage = cropperRef.current.cropper.getCroppedCanvas().toDataURL('image/jpeg', 0.9);
            //console.log("Cropped Image:", croppedImage);
            onCrop(croppedImage);
        }
    };

    return (
        <div css={cropCss}>

            <div className="header">

                {imageType === 'background' ? <Bg/>:   <Profile/>}
                <span className={"font-hangang text-base text-extra font-semibold ml-3"}>  {imageType === 'background' ? '배경 사진 등록':  '프로필 등록'}</span>
                <Close className={"ml-auto items-end justify-end mr-4 cursor-pointer"}  onClick={onClose}/>
            </div>


            <div css={cropperContainerCss}>
                <Cropper
                    style={{ height: '360px', width: '330px' }}
                    zoomTo={0.2}
                    initialAspectRatio={1}
                    preview=".img-preview"
                    src={img}
                    viewMode={1}
                    minCropBoxHeight={10}
                    minCropBoxWidth={10}
                    background={false}
                    responsive={true}
                    autoCropArea={1}
                    checkOrientation={false}
                    guides={true}
                    ref={cropperRef}
                />
            </div>

    {/*        <div className="flex flex-grow">
                <div className="box">
                    <div
                        className="img-preview"
                        style={{ width: "100%", height: "100%" }}
                    />
                </div>
            </div>*/}
            <div css={buttonContainerCss}>
                <input
                    type="file"
                    accept="image/*"
                    ref={fileInputRef}
                    style={{display: 'none'}} // 파일 입력을 숨김
                    onChange={handleImageChange}
                />
                <button id="close" onClick={handleChangeImage}><span
                    className={"font-hangang text-extra text-sm"}>사진 변경</span></button>
                <button id="save" onClick={handleCrop}><span className={"font-hangang text-white text-sm "}>업로드</span>
                </button>
            </div>


        </div>
    );
};

const cropCss = css`
    width: 380px;
    height: 520px;
    flex: 1 0 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;

    .header {
        display: flex;
        height: 72px;
        padding: 12px 4px 12px 16px;
        align-items: center;
        align-self: stretch;
    }

    .box {
        display: inline-block;
        padding: 10px;
        box-sizing: border-box;
    }
    .img-preview {
        overflow: hidden;
        width: 100%;
        height: 100%;
        max-width: 300px;
        max-height: 300px;
    }
`;

const cropperContainerCss = css`
    width: 330px;
    height: 360px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
`;


const buttonContainerCss = css`
    display: flex;
    padding: 16px;
    gap: 8px;
    align-items: center; 
    justify-content: flex-end;
    align-self: stretch;

    #save {
        display: flex;
        padding: 10px 24px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 100px;
        border: 1.2px solid #19CF7A;
        height: 40px;
        background: #19CF7A;
        flex-direction: column;
    }

    #close {
        display: flex;
        padding: 10px 24px;
        justify-content: center;
        align-items: center;
        gap: 8px;
        border-radius: 100px;
        border: 1.2px solid #19CF7A;

    }
`;

export default ImageCrop;
